"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:6.5.4'] && _();
}
catch (e) { }
